// Angular
import { Injectable } from '@angular/core';
// Sore
import { Action, Selector, State, StateContext } from '@ngxs/store';
// Actions
import { Logout } from '../auth/action/auth.action';
// Model
import { UIConfigStateModel, UIConfigStatus } from './model/ui-config.model';
import { LoadUIConfig, SetUIConfig } from './action/ui-config.action';
import { UIConfigService } from './service/ui-config.service';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

@State<UIConfigStateModel>({
	name: 'uiConfig',
	defaults: new UIConfigStateModel()
})
@Injectable()
export class UIConfigState {

	constructor(
		private uiConfigService: UIConfigService) {
	}

	/**
	 * Returns UIConfigState state.
	 * @param state
	 * @constructor
	 */
	@Selector()
	static getUIConfigState(state: UIConfigStateModel): UIConfigStateModel {
		return state;
	}

	/**
	 * Set only the request model from the UI Config this to avoid to save external like reports
	 * that is valid but not for this context
	 * @param ctx
	 * @param uiConfigStateModel
	 */
	@Action(LoadUIConfig)
	loadUIConfig(ctx: StateContext<UIConfigStateModel>, {organizationID, appName}: LoadUIConfig): Observable<any> {
		return this.uiConfigService.loadUIConfig(organizationID).pipe(
			tap(({application = undefined}: UIConfigStateModel) => {
				const uiConfigState = new UIConfigStateModel();
				if (application && application[appName]) {
					// Ensure we only keep what we need to reduce the size of the storage
					ctx.setState({
						status: UIConfigStatus.READY,
						application: {
							[appName]: application[appName]
						}
					});
				} else {
					// UI Config Loaded, but nothing inside for this organization
					uiConfigState.status = UIConfigStatus.NONE;
					ctx.setState(uiConfigState);
				}
			})
		);
	}

	/**
	 * Set the Entire Model after Login, this should be only used to overwrite the entire configuration
	 * @param ctx
	 * @param uiConfigStateModel
	 */
	@Action(SetUIConfig)
	setUIConfig(ctx: StateContext<UIConfigStateModel>, {uiConfigStateModel}: SetUIConfig): void {
		ctx.setState(uiConfigStateModel);
	}

	/**
	 * Clear out the UI Config State Model
	 * @param ctx
	 */
	@Action(Logout)
	logout(ctx: StateContext<UIConfigStateModel>): void {
		ctx.setState(new UIConfigStateModel());
	}
}
